import { IMapEvents } from '../../interfaces/map-event.interface';

export const MapboxMapEvents: IMapEvents = {
  click: 'click',
  load: 'load',
  dblclick: 'dblclick',
  zoomstart: 'zoomstart',
  contextmenu: 'contextmenu',
  movestart: 'movestart',
  rightclick: 'rightclick',
  resize: 'resize',
  zoomanim: 'zoomanim',
  zoomend: 'zoomend',
  zoom: 'zoom',
  mouseover: 'mouseover',
  mousedown: 'mousedown',
  mouseout: 'mouseout',
  mousemove: 'mousemove',
  move: 'move',
  mouseup: 'mouseup',
  moveend: 'moveend',
  drag: 'drag',
  dragstart: 'dragstart',
};

